import { IHelpSection } from './i-help-section.interface';
import { IHelpInfo } from './i-help-info.interface';

export class HelpConsts {
  static CompanyDetailsHelp = {
    sections: [{
      heading: 'Enterprise Details Help',
      body: '<p>You can edit and maintain the contact information for the individual in your organisation in the Enterprise Details Panel. ' +
        'The information is captured from the MyECA website. You may change the contact information specific to this system here but the address information is maintained via the MyECA website.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static OperativeTrainingRecordsHelp = {
    sections: [{
      heading: 'Operative Training Records Help',
      body: '<p>This page shows a list of all operative training records. You can sort and search for particular records here, including exporting the information to Excel.</p>' +
        '<p>You can also view and edit a an existing record by clicking on View in the particular row. You may also remove a record using the Remove option from the context menu for the particular row.</p>' +
        '<p>If you wish to add a new training record, you should navigate to the Our Operatives page and select the Operative or Operatives you wish to add a new record to.</p>'

    }] as IHelpSection[]
  } as IHelpInfo;
  static DashboardOperativesListHelp = {
    sections: [{
      heading: 'Dashboard Operatives List Help',
      body: '<p>On the Enterprise dashboard, a list of your current operatives are shown. ' +
        'The current Job Role, Work Risk, Job Level are shown along with the calculated Supervision required for the particular operative according to the EAS guidance. ' +
        'Furthermore, the individual\'s level of supervision is highlighted in \'traffic lighted\' row colours.</p>' +
        '<p>When there are observations or followups due on the operative, the next applicable date is also shown</p>' +
        '<p>Quick actions to <strong>Add New</strong> operative to your team, and to <strong>Manage</strong> ' +
        'the operatives more closely, are provided on the title of the panel. To get an overview of the EAS guidance for your current workforce, you can click the <strong>EAS</strong> button</b>.</p>' +
        '<p>To see the detailed information that is stored on an individual operative you can click <strong>View</strong> on respective row\'s context menu. You may also remove and individual from this screen.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static RecentDocumentsList = {
    sections: [{
      heading: 'Recent Documents List',
      body: '<p>Documents that have been added in the last month are shown in the Recent Documents panel.</p>' +
        '<p>Documents can be added a various levels throughout the system to store documentation and evidence of Enterprise information and operative competence for example. The levels include</p>' +
        '<ul>' +
        '<li>General Enterprise documents</li>' +
        '<li>General operative documents</li>' +
        '<li>Operative training records documents</li>' +
        '</ul>' +
        '<p>You can view the particular document from the context menu in this panel and you can use the quick action buttons to <strong>Add Enterprise Document</strong>s or to ' +
        '<strong>Manage</strong> Enterprise documents more closely and to view documents older than the most recent ones shown in this panel.</p>' +
        '<p>To add documents to operative records, you should open the individual operative in question and add documents directly to their record or to their training records.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static RecentObservationsList = {
    sections: [{
      heading: 'Recent Observations List',
      body: '<p>The Recent Observations panel shows observations that have been made to your various records in the past month</p>' +
        '<p>Observations are the mechanism whereby use can record details of inspections that have been made on the various records throughout the eCOMS system. This helps to demonstrate that you are keeping information ' +
        'up to date and have procedures in place to review this information at periodic intervals. The types of information your can record observations against include: </p>' +
        '<ul>' +
        '<li>General Enterprise information</li>' +
        '<li>Enterprise documents</li>' +
        '<li>General operative information</li>' +
        '<li>Operative documents</li>' +
        '<li>Operative training records and their documents</li>' +
        '</ul>' +
        '<p>On this panel, you can view a particular observation from the table row\'s context menu and you can use the quick action buttons to <strong>Add Enterprise Observation</strong>s or to ' +
        '<strong>Manage</strong> Enterprise based observations more closely and to see  observations older than the most recent ones shown on this panel.</p>' +
        '<p>To make observations on operative records, you should open the individual operative in question where you can observe their details, their training records and their documents from there.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static TrainingRecordHelp = {
    sections: [{
      heading: 'Training Record Help',
      body: '<p>The training record screen allows you to record training, ' +
        'qualifications and other experience that you wish to record against an operative to help ensure that you are managing their skills and competence.\n </p>' +
        '<p>Once you have added training records you can make observations on them and attach documents to the training record to further manage the operative\'s competence.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static AllOperativeDocumentsHelp = {
    sections: [{
      heading: 'All Operative Documents Help',
      body: '<p>This screen shows a list of documents recorded against operatives or their training records. If you would like to add new documents to an operative, then you should navigate to the operatives list and select the operative in question and perform the action there.</p>' +
        '<p>You can view and remove an existing document by selecting the required operation from table row context menu for the particular document record.</p>' +
        '<p>To see old "expired" information, you can click the Include Expired checkbox.</p>' +
        '<p>You may also, search and export the table information to excel.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static AllOperativeObservationsHelp = {
    sections: [{
      heading: 'All Operative Observations Help',
      body: '<p>This screen shows a list of observations recorded against operatives or their training records or their documents. If you would like to add new observates to an operative, then you should navigate to the operatives list and select the operative in question and perform the action there.</p>' +
        '<p>You can view and remove an existing observation by selecting the required operation from the table row context menu for the particular observation record.</p>' +
        '<p>You may also, search and export the table information to excel.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static CompanyObservationsHelp = {
    sections: [{
      heading: 'Enterprise Observations Help',
      body: '<p>This screen shows a list of Observations that have been recorded on the Enterprise itself or its documents.</p>' +
        '<p>You can add a new observation directly on the Enterprise via the Add button or you can edit or remove existing observations via the corresponding table row context menu.</p>' +
        '<p>You may also, search and export the table information to excel.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static CompanyOperativesHelp = {
    sections: [{
      heading: 'Enterprise Operatives Help',
      body: '<p>This is the Operatives List page.</p>' +
        '<p>The operatives in recorded as having worked in Roles with your organisation are shown here. By default, this page loads with operatives that have a current role with your organisation. To see past Operatives ' +
        'you can change select a different date in the <b>Show as of</b> date control. Doing so will refresh the table with operatives that were in a role during that time.</p>' +
        '<p>The Operative\'s name, reference no if any, current Job Role, Work Risk, Job Level are shown, along with the calculated Supervision required for the particular operative according to the EAS guidance. ' +
        'Furthermore, the individual\'s level of supervision is highlighted in \'traffic lighted\' row colours. The date the Operative\'s role started on is shown as is the date the role ended if there was one</p>' +
        '<p>When there are observations or followups due on the operative, the next applicable date is also shown</p>' +
        '<p>The table can be sorted by individual columns and also filtered by Work Risk, Job Level and Supervision. The table can also be exported to Excel via the <b>Export</b>b> button.</p>' +
        '<p>To see an individual Operative\'s details in more detail, you can click the <b>View</b> button in the corresponding table row.</p>' +
        '<p>For each operative row, there is also a context menu visible by clicking the ellipsis buttons (three vertical dots). From the row menu, you can remove the respective operative.</p>' +
        '<p>You may also <strong>Add New Operative</strong> via the appropriate button above the table. You can use this to add a complete new operative or to bring a past operative back into a new role with your company.</p>' +
        '<p>Finally, you can perform operations on multiple Operative records but using the checkbox selectors at the start of each column or select the checkbox in the header row to select them all.' +
        'Once you have selected at least one operative in this manner, you can use the <b>Add Training Records</b> to add the same training information to all the selected operatives, or you can use the <b>Remove Operatives</b> button to remove them from you company by setting their roles as ended.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static CompanyDocumentsHelp = {
    sections: [{
      heading: 'Enterprise Documents Help',
      body: '<p>This screen shows a list of documents recorded for the Enterprise itself. Examples here could include items such as corporate structure, health and safety documentation, etc</p>' +
        '<p>You can add to the list of documents via the Add button or edit or remove existing documents via the corresponding table row context menu.</p>' +
        '<p>To see old "expired" information, you can click the Include Expired checkbox.</p>' +
        '<p>You may also, search and export the table information to excel.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static DocumentsEntryHelp = {
    sections: [{
      heading: 'Document Entry Help',
      body: '<p>On this screen, you can enter the details about a document. Mandatory details include:</p>' +
        '<ul>' +
        '<li>The type of the document - selected from drop-down. If Other type is selected than the additional information field is required</li>' +
        '<li>The date the document was first created/written. This will most often not coincide to the date you uploaded it here.</li>' +
        '<li>The file itself - selected via the Choose File button. You can also drag a file and drop it here if you wish.</li>' +
        '</ul>' +
        '<p>Optional information includes:</p>' +
        '<ul>' +
        '<li>Additional Information text - if the Document Type is "Other" than this field is mandatory</li>' +
        '<li>An expiry date - for when the document may have a specific life-time and you wish it to automatically be hidden after it expires.</li>' +
        '<li>A review date - to record when this document should be reviewed. When the review date passes, an alert will be created on the system to bring your attention to the fact.' +
        ' this functionality is useful when a document such as Health and Safety policies etc need periodic review.</li>' +
        '</ul>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static SupervisionAlertsHelp = {
    sections: [{
      heading: 'Supervision Alerts Help',
      body: '<p>This page shows you a simple list of your current operatives that are flagged as requiring a High level of supervision in their work.</p>' +
        '<p>You can navigate to the particular operative record via the View button on their corresponding row in the table.</p>' +
        '<p>You can also sort, search and export the table to Excel</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static ActionAlertsHelp = {
    sections: [{
      heading: 'Action Alerts Help',
      body: '<p>This page shows you a list of items that need attention. These items may include follow-ups due on operatives or training records or documents expired or due for review</p>' +
        '<p>You can action an item by looking up the particular record and changing the follow-up details for instance. Or you can click Dismiss on the particular row to dismiss the alert.</p>' +
        '<p>You can also sort, search and export the table to Excel.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static TrainingTypesHelp = {
    sections: [{
      heading: 'Training Types Help',
      body: '<p>General training types.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static TrainingCourseEntrysHelp = {
    sections: [{
      heading: 'Training Course Entry Help',
      body: '<p>Here you can create Enterprise based training courses or Enterprise based training types that will be available when adding training records to operatives.</\p>' +
        '<p>Add a Name for the Training that will be visible from the training record drop-down and also a Description about the course for your records. You can also add an optional "Held On" date if this course was held on a particular day</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static JobTitlesHelp = {
    sections: [{
      heading: 'Job Roles Help',
      body: '<p>List of job roles.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static DocumentTypesHelp = {
    sections: [{
      heading: 'Document Types Help',
      body: '<p>Document types.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static OptInEntryHelp = {
    sections: [{
      heading: 'OptIn Entry Help',
      body: '<p>OptIn Entries.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static OptInModalHelp = {
    sections: [{
      heading: 'OptIn Modal Help',
      body: '<p>OptIn Modal Details.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static CompanyTrainingCoursesHelp = {
    sections: [{
      heading: 'Enterprise Training Courses Help',
      body: '<p>This screen shows any saved Enterprise-based training courses that are available for selection when adding training records to one or more of your operatives.</p>' +
        '<p>You can add new Enterprise based training courses here or edit or remove existing ones by selecting the appropriate record via is corresponding table row context menu.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static CompanySearchHelp = {
    sections: [{
      heading: 'Enterprise Search Help',
      body: '<p>You can search and select Enterprise which you want to manage.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static Admin = {
    sections: [{
      heading: 'Admin Dashboard Help',
      body: '<p>Admin Dashboard.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static OperativeDetails = {
    sections: [{
      heading: 'Operative Details Help',
      body: '<p>On this page you can view and edit everything about an individual operative</p>' +
        '<p>The page is split into three main sections:' +
        '<ul>' +
        '<li>The Operative name and contact details, including any reference number such as a ECS card number</li>' +
        '<li>The operative\'s Current Role, including the Operative\'s current Job Role and Job Level, the Degree or Risk in they current Work and the dates they are in the role. The End Date input can be left blank if this role is ongoing</li>' +
        '<li>And the bottom section is presented in multiple tabs to show the operative\'s Training Records, Documents, Observations and Role History</li>' +
        '</ul></p>' +
        // tslint:disable-next-line:max-line-length
        '<p>The current role section also shows the current Level of Supervision that the Operative requires according to the EAS guidance.' +
        'The panel\'s background is also coloured according to the traffic light system to easily see supervision requirements for the Operative</p>' +
        '<p>To see information about the operative\'s Training Records, Documents, observations and Role History, click on the respective tab heading.' +
        'Each tab will show a table of the applicable data and the ability to edit and add new items.' +
        ' Each table displayed can be export and sorted as with all tables in the system. You can also edit individual records using the row menus.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
//  <p>This screen shows the status of the operatives according to the < a[href]="\'https://electrical.theiet.org/bs-7671/building-regulations/electrotechnical-assessment-specification/\'" target = "_blank" > EAS(Electrotechnical Assessment Specification) Guidance < /a>' +
//' and the tables contained in the Appendices of the guidance documents</p>
  static EasGuidance = {
    sections: [{
      heading: 'EAS Guidance',
      body: 
        "<p>On this screen you can quickly see the job levels, work risks and importantly the amount of supervision required.</p>" +
        "<p>At the bottom of the screen you can click 'Print' to print a copy of the guidance to a printer or to PDF via your operating system.</p>"
    }] as IHelpSection[]
  } as IHelpInfo;
  static ObservationGuidance = {
    sections: [{
      heading: 'Observations Help',
      body: '<p>The Observation screen allows you to record observations for Enterprise, operatives, training records, and documents.<p>' +
        '<p>Observations are a key part of the EAS guidance to demonstrate the Enterprise records are maintained and reviewed. Also to support the EAS Guidance, you should also monitor and record observations.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static ObservationEntryHelp = {
    sections: [{
      heading: 'Observations Entry Help',
      body: '<p>On this screen you should record the details about an observation. Mandatory fields include:<p>' +
        '<ul>' +
        '<li>The name of the individual who made the observation, Observed By</li>' +
        '<li>A basic Summary of what the observation was about or why it was made.</li>' +
        '<li>The date the observation was made, Observed On</li>' +
        '</ul>' +
        '<p>Optional information includes:</p>' +
        '<ul>' +
        '<li>A follow up date - to record when there should be a follow up observation made. When the follow-up date passes, an alert will be created on the system to bring your attention to the fact.' +
        ' This functionality is useful to help ensure that observations continue regularly.</li>' +
        '<li>Notes can also be recorded in a rich text input to record more information that maybe pertinent to the observation</li>' +
        '</ul>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static ObservationDetailsHelp = {
    sections: [{
      heading: 'Observations Details Help',
      body: '<p>On this screen you should record the details about an observation. Mandatory fields include:<p>' +
        '<ul>' +
        '<li>The name of the individual who made the observation, Observed By</li>' +
        '<li>A basic Summary of what the observation was about or why it was made.</li>' +
        '<li>The date the observation was made, Observed On</li>' +
        '</ul>' +
        '<p>Optional information includes:</p>' +
        '<ul>' +
        '<li>A follow up date - to record when there should be a follow up observation made. When the follow-up date passes, an alert will be created on the system to bring your attention to the fact.' +
        ' This functionality is useful to help ensure that observations continue regularly.</li>' +
        '<li>Notes can also be recorded in a rich text input to record more information that maybe pertinent to the observation</li>' +
        '</ul>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static ObservationDocumentDetailsHelp = {
    sections: [{
      heading: 'All Observation Documents Help',
      body: '<p>This screen shows a list of documents recorded against Observation or their training records. If you would like to add new documents to an operative, then you should navigate to the operatives list and select the operative in question and perform the action there.</p>' +
        '<p>You can view and remove an existing document by selecting the required operation from table row context menu for the particular document record.</p>' +
        '<p>To see old "expired" information, you can click the Include Expired checkbox.</p>' +
        '<p>You may also, search and export the table information to excel.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static CompanyDashboardHelp = {
    heading: 'Enterprise Dashboard Help',
    sections: [
      HelpConsts.CompanyDetailsHelp.sections[0], HelpConsts.DashboardOperativesListHelp.sections[0],
      HelpConsts.RecentDocumentsList.sections[0], HelpConsts.RecentObservationsList.sections[0]
    ] as IHelpSection[]
  } as IHelpInfo;
  static AuditHistoryHelp = {
    sections: [{
      heading: 'Audit History Help',
      body: '<p>The Audit History Screen allows you to view a complete timeline of changes made across your entire Enterprise.</p>' +
        '<p>If you require more details about any audit entry then please contact your local ECA Regional Manager</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
  static CompanySettingJobRoleHelp = {
    sections: [{
      heading: 'Job Role Help',
      body: '<p>Only can ADD, EDIT, DELETE FOR Operative type "Non Electrical"' +
        '<p>just do it</p>'
    }] as IHelpSection[]
  } as IHelpInfo;

  static BusinessUnitHelp = {
    sections: [{
      heading: 'Business Unit Help',
      body: '<p>Defining your own business units allow you to split your operatives into there respective areas/departments to make managing your operatives easier</p>'
    }] as IHelpSection[]
  } as IHelpInfo;

  static BusinessUnitInUseHelp = {
    sections: [{
      heading: 'Business Unit In Use',
      body: '<p>This business unit has been used against an operative record (current or past engagement) and therefore cannot be deleted.</p>'
    }] as IHelpSection[]
  } as IHelpInfo;
}
